import script from "./Variables.vue?vue&type=script&setup=true&lang=js"
export * from "./Variables.vue?vue&type=script&setup=true&lang=js"

import "./Variables.vue?vue&type=style&index=0&id=63aa9589&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63aa9589"]])

export default __exports__